import React, { useState } from "react";
import "./ShadeCards.css";
import weatherGuard from "../assets/paintNavy4.png";
import plasticEmulsion from "../assets/paintblue4.png";
import mattEmulsion from "../assets/paintpink4.png";
import highClass from "../assets/paintRed4.png";
import glossEnamel from "../assets/paintGloss4.png";

const categories = [
  {
    id: "weatherGuard",
    name: "Weather Guard",
    img: weatherGuard,
    shades: [
      {
        name: "Carnival Pink",
        color: "#C10FB7",
        pantone: "4157 C",
        rgb: "(193, 15, 183, 1)",
      },
      {
        name: "Pastel Green",
        color: "#CED1AD",
        pantone: "4157 C",
        rgb: "(206, 209, 173, 1)",
      },
      {
        name: "Light Blue",
        color: "#BAEBF4",
        pantone: "4157 C",
        rgb: "(186, 235, 244, 1)",
      },
      {
        name: "Melody Green",
        color: "#CAF2D0",
        pantone: "4157 C",
        rgb: "(202, 242, 208, 1)",
      },
      {
        name: "Fresh Green",
        color: "#CED37D",
        pantone: "4157 C",
        rgb: "(206, 211, 125, 1)",
      },
      {
        name: "Pink",
        color: "#FFE3ED",
        pantone: "4157 C",
        rgb: "(255, 227, 237, 1)",
      },
      {
        name: "Classical",
        color: "#D0CBDE",
        pantone: "4157 C",
        rgb: "(208, 203, 222, 1)",
      },
    ],
  },
  {
    id: "plasticEmulsion",
    name: "Plastic Emulsion",
    img: plasticEmulsion,
    shades: [
      {
        name: "Neutrals & Pastels",
        color: "#D8A48F",
        pantone: "4157 C",
        rgb: "(216, 164, 143, 1)",
      },
      {
        name: "Warm & Earthy",
        color: "#D7CE93",
        pantone: "4157 C",
        rgb: "(215, 206, 147, 1)",
      },
      {
        name: "Metallics & Textures",
        color: "#BB8487",
        pantone: "4157 C",
        rgb: "(187, 132, 135, 1)",
      },
      {
        name: "Turquoise",
        color: "#A3A37F",
        pantone: "4157 C",
        rgb: "(163, 163, 127, 1)",
      },
      {
        name: "Cool & Calm",
        color: "#94B6BB",
        pantone: "4157 C",
        rgb: "(148, 182, 187, 1)",
      },
      {
        name: "Bold & Bright",
        color: "#BF7C29",
        pantone: "4157 C",
        rgb: "(191, 124, 41, 1)",
      },
      {
        name: "Seasonal Trends ",
        color: "#6C5854",
        pantone: "4157 C",
        rgb: "(108, 88, 84, 1)",
      },
    ],
  },
  {
    id: "mattEmulsion",
    name: "Aquatic Matt Emulsion",
    img: mattEmulsion,
    shades: [
      {
        name: "Pastel Green",
        color: "#CED1AD",
        pantone: "4157 C",
        rgb: "(206, 209, 173, 1)",
      },
      {
        name: "Classical",
        color: "#D0CBDE",
        pantone: "4157 C",
        rgb: "(208, 203, 222, 1)",
      },
      {
        name: "Carnival Pink",
        color: "#C981B2",
        pantone: "4157 C",
        rgb: "(201, 129, 178, 1)",
      },
      {
        name: "Light Blue",
        color: "#BAEBF4",
        pantone: "4157 C",
        rgb: "(186, 235, 244, 1)",
      },
      {
        name: "Buttercup Bouquet",
        color: "#FFED9A",
        pantone: "4157 C",
        rgb: "(255, 237, 154, 1)",
      },
      {
        name: "Goose Wing ",
        color: "#A8ABA3",
        pantone: "4157 C",
        rgb: "(168, 171, 163, 1)",
      },
      {
        name: "Hush Rose",
        color: "#FDEDE0",
        pantone: "4157 C",
        rgb: "(253, 237, 224, 1)",
      },
    ],
  },
  {
    id: "highClass",
    name: "High Class Emulsion",
    img: highClass,
    shades: [
      {
        name: "Paraffin",
        color: "#F1F1E3",
        pantone: "4157 C",
        rgb: "(241, 241, 227, 1)",
      },
      {
        name: "Metallics & Textures",
        color: "#BB8487",
        pantone: "4157 C",
        rgb: "(187, 132, 135, 1)",
      },
      {
        name: "Fresh Green",
        color: "#CED37D",
        pantone: "4157 C",
        rgb: "(206, 211, 125, 1)",
      },
      {
        name: "Classical",
        color: "#D0CBDE;",
        pantone: "4157 C",
        rgb: "(208, 203, 222, 1)",
      },
      {
        name: "Peach Cream ",
        color: "#D8A48F",
        pantone: "4157 C",
        rgb: "(235, 183, 143, 1)",
      },
      {
        name: "Pink",
        color: "#FFE3ED",
        pantone: "4157 C",
        rgb: "(255, 227, 237, 1)",
      },
      {
        name: "Cool & Calm",
        color: "#94B6BB",
        pantone: "4157 C",
        rgb: "(148, 182, 187, 1)",
      },
    ],
  },
  {
    id: "glossEnamel",
    name: "Gloss Enamel",
    img: glossEnamel,
    shades: [
      {
        name: "Metallics & Textures",
        color: "#BB8487",
        pantone: "4157 C",
        rgb: "(187, 132, 135, 1)",
      },
      {
        name: "Hush Rose",
        color: "#FDEDE0",
        pantone: "4157 C",
        rgb: "(253, 237, 224, 1)",
      },
      {
        name: "Grey Dew",
        color: "#DFEAEC",
        pantone: "4157 C",
        rgb: "(223, 234, 236, 1)",
      },
      {
        name: "Seasonal Trends",
        color: "#6C5854",
        pantone: "4157 C",
        rgb: "(108, 88, 84, 1)",
      },
      {
        name: "Pink",
        color: "#FFE3ED",
        pantone: "4157 C",
        rgb: "(255, 227, 237, 1)",
      },
      {
        name: "Gold Mist",
        color: "#B4AC3D",
        pantone: "4157 C",
        rgb: "(180, 172, 61, 1)",
      },
      {
        name: "Melody Green",
        color: "#CAF2D0",
        pantone: "4157 C",
        rgb: "(202, 242, 208, 1)",
      },
    ],
  },
];

export default function ShadeCards() {
  const [activeCategory, setActiveCategory] = useState("weatherGuard");
  const activeShades =
    categories.find((c) => c.id === activeCategory)?.shades || [];

  return (
    <section className="shade-section">
      <h2>Browse Our Shade Cards</h2>
      <p>
        Take the guesswork out of painting. Our curated shade cards help you
        explore colour families, combinations, and trending tones.
      </p>
      <p>Choose your paint category</p>

      {/* Category selector */}
      <div className="category-row">
        {categories.map((cat) => (
          <div
            key={cat.id}
            className={`category-item ${
              activeCategory === cat.id ? "active" : ""
            }`}
            onClick={() => setActiveCategory(cat.id)}
          >
            <img src={cat.img} alt={cat.name} />
            <span>{cat.name}</span>
          </div>
        ))}
      </div>

      <h3 className="shade-title">
        Glamur {categories.find((c) => c.id === activeCategory)?.name} Shades
      </h3>

      {/* ✅ Dynamic Shades Grid */}
      <div className="shade-wrapper">
        <div className="shade-row">
          {activeShades.slice(0, 4).map((shade, i) => (
            <div
              key={i}
              className="shade-card"
              style={{ border: `15px solid ${shade.color}` }}
            >
              <p>{shade.name}</p>
              <small>
                PANTONE: {shade.pantone} <br />
                HEX COLOR: {shade.color} <br />
                RGB: {shade.rgb} <br />
              </small>
              <div
                className="shade-color"
                style={{ backgroundColor: shade.color }}
              ></div>
            </div>
          ))}
        </div>

        {activeShades.length > 4 && (
          <>
            {/* Divider Image */}
            <div className="shade-divider">
              <img src="/assets/mid-line.png" alt="divider" />
            </div>

            <div className="shade-row">
              {activeShades.slice(4, 7).map((shade, i) => (
                <div
                  key={i}
                  className="shade-card"
                  style={{ border: `15px solid ${shade.color}` }}
                >
                  <p>{shade.name}</p>
                  <small>
                    PANTONE: {shade.pantone} <br />
                    HEX COLOR: {shade.color} <br />
                    RGB: {shade.rgb} <br />
                  </small>
                  <div
                    className="shade-color"
                    style={{ backgroundColor: shade.color }}
                  ></div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <button className="explore-btn">Explore Full Palette</button>

      {/* ✅ Mobile Version */}
      <div className="shade-mobile">
        <h2>Browse Our Shade Cards</h2>
        <p>
          Take the guesswork out of painting. Our curated shade cards help you
          explore colour families, combinations, and trending tones.
        </p>

        <div className="mobile-carousel">
          <button
            className="mobile-arrow left"
            onClick={() =>
              setActiveCategory((prev) => {
                const i = categories.findIndex((c) => c.id === prev);
                return categories[
                  (i - 1 + categories.length) % categories.length
                ].id;
              })
            }
          >
            ‹
          </button>

          <div className="mobile-bucket">
            <img
              src={categories.find((c) => c.id === activeCategory)?.img}
              alt="Paint Bucket"
            />
            <h3>{categories.find((c) => c.id === activeCategory)?.name}</h3>
          </div>

          <button
            className="mobile-arrow right"
            onClick={() =>
              setActiveCategory((prev) => {
                const i = categories.findIndex((c) => c.id === prev);
                return categories[(i + 1) % categories.length].id;
              })
            }
          >
            ›
          </button>
        </div>

        <h4 className="mobile-subtitle">
          Glamur {categories.find((c) => c.id === activeCategory)?.name} Shades
        </h4>

        <div className="mobile-shades-grid">
          {categories
            .find((c) => c.id === activeCategory)
            ?.shades.map((shade, i) => (
              <div
                key={i}
                className="mobile-shade"
                style={{ borderColor: shade.color }}
              >
                <div className="mobile-shade-info">
                  <p>{shade.name}</p>
                  <small>
                    PANTONE: {shade.pantone} <br />
                    HEX: {shade.color} <br />
                    RGB: {shade.rgb}
                  </small>
                </div>
                <div
                  className="mobile-shade-color"
                  style={{ backgroundColor: shade.color }}
                ></div>
              </div>
            ))}
        </div>

        <button className="explore-btn">Explore Full Palette</button>
      </div>
    </section>
  );
}
